import { render, staticRenderFns } from "./link-table-column-input-number.vue?vue&type=template&id=624b5b84&scoped=true&"
import script from "./link-table-column-input-number.vue?vue&type=script&lang=js&"
export * from "./link-table-column-input-number.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624b5b84",
  null
  
)

export default component.exports